module.exports = __webpack_public_path__ + "static/media/registerP2.46304e2c.jpeg";